// src/App.tsx
import React from "react";
import { withAuthenticationRequired } from "@auth0/auth0-react";
import Loader from "./components/loader/Loader";
import Auth0Provider from "./features/auth/auth0Provider";
import PermissionProvider from "./features/configurations/PermissionProvider";
import { Routers } from "./router";

function App() {
  return (
    <Auth0Provider>
      <PermissionProvider>
        <Routers />
      </PermissionProvider>
    </Auth0Provider>
  );
}

export default withAuthenticationRequired(App, {
  onRedirecting: () => <Loader />,
});
